export function CopyPasteNormalizer (pEditor)
{
  this.normalize = (content, args = {}) =>
  {
    const removeEmptyBlocks = (element) =>
    {
      return {'isRemove': (element.innerHTML.replace(/\s+/g, '') === ''), 'isChange': false, 'element': null};
    };

    let trueBlockTags = 'P, H1, H2, H3, H4, H5, H6, LI, BLOCKQUOTE, TH, TD',
        reTrueBlockTags = /^(?:P|H[1-6]|LI|BLOCKQUOTE|TH|TD)$/i,
        trueFontSizeTags = /^(?:P|H[1-6]|LI|BLOCKQUOTE|TH|TD|A|SPAN|STRONG|B|EM|I|U|S|STRIKE|SUP|SUB|FONT)$/i;

    args.rules =
    {
      trueTags:
      {
        'P': removeEmptyBlocks,
        'H1': removeEmptyBlocks,
        'H2': removeEmptyBlocks,
        'H3': removeEmptyBlocks,
        'H4': removeEmptyBlocks,
        'H5': removeEmptyBlocks,
        'H6': removeEmptyBlocks,
        'UL': true,
        'OL': true,
        'LI': true,
        'BLOCKQUOTE': true,
        'TABLE': true,
        'THEAD': true,
        'TBODY': true,
        'TFOOT': true,
        'TR': true,
        'TH': true,
        'TD': true,
        'DIV': function (element)
        {
          let isChange = false,
              isRemove = false,
              isNotModify = false,
              parentElement;

          if (pEditor.$Style(element, 'position').toLowerCase() !== 'absolute')
          {
            if (element.hasAttribute('data-componentId') || element.hasAttribute('data-editableArea') || element.innerHTML.replace(/\s+/g, '') === '')
            {
              isRemove = true;
            }
            else
            {
              parentElement = element.parentElement;
              element.outerHTML = element.outerHTML.replace(/^<div/i, '<p data-wadivtagconverter="1"').replace(/div>$/i, 'p>');
              element = parentElement.querySelector('P[data-wadivtagconverter]');
              element.removeAttribute('data-wadivtagconverter');
              isChange = true;
            }
          }
          else
          {
            isNotModify = true;
          }

          return {'isRemove': isRemove, 'isChange': isChange, 'isNotModify': isNotModify, 'element': (isChange ? element : null)};
        },
        'A': true,
        'IMG': function (element) { return {'isRemove': (/^file:/i).test(element.getAttribute('src')), 'isChange': false, 'element': null}; },
        'BR': true,
        'SPAN': true,
        'STRONG': true,
        'B': true,
        'EM': true,
        'I': true,
        'U': true,
        'S': true,
        'STRIKE': true,
        'SUP': true,
        'SUB': true,
        'FONT': true
      },

      reEmptyTags: /^(?:P|H[1-6]|BLOCKQUOTE|A|SPAN|STRONG|B|EM|I|U|S|STRIKE|SUP|SUB|FONT)$/i,
      reEmptyTagsReplace: /<(?:P|H[1-6]|BLOCKQUOTE|A|SPAN|STRONG|B|EM|I|U|S|STRIKE|SUP|SUB|FONT)(?:\s[^>]*>|>)\s*<\/(?:P|H[1-6]|BLOCKQUOTE|A|SPAN|STRONG|B|EM|I|U|S|STRIKE|SUP|SUB|FONT)>/ig,

      trueAttributes:
      {
        'face':
        {
          'tags': /FONT/i,
          'values': /./i,
          'trans': function (element, attr)
          {
            if (attr.value.toLowerCase().indexOf('awesome') !== -1 && attr.value !== 'FontAwesome')
            {
              attr.value = attr.value.replace(/^(\s*|.*?,\s*|.*?(?:['"]|&quot;))font\s*awesome[^,]*(,.*)?$/i, '$1FontAwesome$2');
            }
          }
        },

        'color':
        {
          'tags': /FONT/i,
          'values': /^(?:#[A-F0-9]+|[A-Z]+)$/i
        },

        'align':
        {
          'tags': /^(?:P|H[1-6]|DIV|TD|IMG)$/i,
          'values': function (element, value) { return ((element.nodeName === 'IMG') ? (/^(?:left|right)$/i).test(value) : (/^(?:left|center|right|justify)$/i).test(value)); }
        },

        'valign':
        {
          'tags': /TD/i,
          'values': /^(?:top|middle|bottom)$/i
        },

        'width':
        {
          'tags': /^(?:IMG|TABLE|TH|TD)$/i,
          'values': /^\d+(?:px|%)?$/i
        },

        'height':
        {
          'tags': /^(?:IMG|TABLE|TH|TD)$/i,
          'values': /^\d+(?:px|%)?$/i,
          'trans': function (element, attr)
          {
            if (BEditor.browser.isIE && attr.value.indexOf('%') !== -1 && (element.nodeName === 'TH' || element.nodeName === 'TD'))
            {
              element.removeAttribute(attr.name);
            }
          }
        },

        'alt':
        {
          'tags': /IMG/i,
          'values': /./i
        },

        'title':
        {
          'tags': /^(?:IMG|A)$/i,
          'values': /./i
        },

        'src':
        {
          'tags': /IMG/i,
          'values': /./i
        },

        'href':
        {
          'tags': /A/i,
          'values': /./i
        },

        'name':
        {
          'tags': /A/i,
          'values': /./i
        },

        'border':
        {
          'tags': /^(?:IMG|TABLE)$/i,
          'values': /^\d+(?:px)?$/i,
          'trans': function (element, attr)
          {
            let value,
                parentTag;

            if (element.nodeName === 'TABLE')
            {
              parentTag = element.querySelector('TH, TD');
              value = attr.value ? parseInt(attr.value.replace(/\D/g, '')) : null;

              if (parentTag && value && !isNaN(value))
              {
                element.style.borderCollapse = 'collapse';
                pEditor.table.edit.setTableBorderAndBackground({}, { 'command': 'setTableBorderWidth', 'value': value + 'px', 'parentTag': parentTag, 'isStaticCall': true });
                pEditor.table.edit.setTableBorderAndBackground({}, { 'command': 'setTableAllCellsBorderWidth', 'value': value + 'px', 'parentTag': parentTag, 'isStaticCall': true });
              }

              element.removeAttribute(attr.name);
            }
          }
        },

        'bordercolor':
        {
          'tags': /TABLE/i,
          'values': /^(?:#[A-F0-9]+|[A-Z]+)$/i,
          'trans': function (element, attr)
          {
            let parentTag = element.querySelector('TH, TD'),
                value = attr.value;

            if (parentTag && value)
            {
              element.style.borderCollapse = 'collapse';
              pEditor.table.edit.setTableBorderAndBackground({}, { 'command': 'setTableBorderColor', 'value': value, 'parentTag': parentTag, 'isStaticCall': true });
              pEditor.table.edit.setTableBorderAndBackground({}, { 'command': 'setTableAllCellsBorderColor', 'value': value, 'parentTag': parentTag, 'isStaticCall': true });
            }

            element.removeAttribute(attr.name);
          }
        },

        'cellspacing':
        {
          'tags': /TABLE/i,
          'values': /^\d+(?:px)?$/i
        },

        'cellpadding':
        {
          'tags': /TABLE/i,
          'values': /^\d+(?:px)?$/i
        },

        'bgcolor':
        {
          'tags': /TABLE/i,
          'values': /^(?:#[A-F0-9]+|[A-Z]+)$/i
        },

        'style':
        {
          'tags': /./,
          'values': /./
        },

        'data-':
        {
          'tags': /./i,
          'values': /./i
        }
      },

      trueStyles:
      [
        {
          'rule': 'position',
          'tags': /^(?:DIV|IMG)$/i,
          'values': /absolute/i
        },

        {
          'rule': 'borderWidth',
          'tags': /^(?:TABLE|TH|TD)$/i,
          'values': /\d+px/i
        },

        {
          'rule': 'borderStyle',
          'tags': /^(?:TABLE|TH|TD)$/i,
          'values': /solid/i
        },

        {
          'rule': 'borderColor',
          'tags': /^(?:TABLE|TH|TD)$/i,
          'values': /^(?:#[A-F0-9]+|[A-Z]+|rgba?\s*\((?:\s*\d+\s*,){2,3}\s*\d+\s*\))$/i
        },

        {
          'rule': 'borderCollapse',
          'tags': /TABLE/i,
          'values': /collapse/i
        },

        {
          'rule': 'fontSize',
          'tags': /FONT/i,
          'values': /\d+px/i
        },

        {
          'rule': 'backgroundColor',
          'tags': /^(?:TH|TD|FONT|SPAN)$/i,
          'values': /^(?:#[A-F0-9]+|[A-Z]+|rgba?\s*\((?:\s*\d+\s*,){2,3}\s*\d+\s*\))$/i
        },

        {
          'rule': 'lineHeight',
          'tags': /^(?:P|H[1-6]|OL|UL|LI|BLOCKQUOTE|TH|TD)$/i,
          'values': /^\d*(?:\.\d+)?(?:px|pt|em|%)?$/i,
          'trans': function (element, rule, value)
          {
            return {'rule': rule, 'value': pEditor.style.lineHeight.normalizeLineHeight(value, element) + 'px'};
          }
        }
      ],

      styles2Tags:
      [
        {
          'rule': 'fontWeight',
          'value': /^bold$/i,
          'tag': 'strong'
        },

        {
          'rule': 'fontStyle',
          'value': /^italic$/i,
          'tag': 'em'
        },

        {
          'rule': 'fontSize',
          'value': /^\d+p[xt]$/i,
          'trans': function (element, value)
          {
            let i,
                blockTags,
                values;

            if (trueFontSizeTags.test(element.nodeName))
            {
              values = value.match(/^(\d+)(p[xt])$/i);

              if (values && values.length === 3)
              {
                if (values[2].toLowerCase() === 'pt')
                {
                  value = Math.round(values[1] * 1.333) + 'px';
                }

                if (value)
                {
                  if (element.nodeName === 'FONT')
                  {
                    element.style.fontSize = value;
                  }
                  else
                  {
                    if (reTrueBlockTags.test(element.nodeName))
                    {
                      blockTags = element.querySelectorAll(trueBlockTags);

                      for (i = blockTags.length; i--;)
                      {
                        blockTags[i].innerHTML = '<font style="font-size: ' + value + ';">' + blockTags[i].innerHTML + '</font>';
                      }
                    }

                    element.innerHTML = '<font style="font-size: ' + value + ';">' + element.innerHTML + '</font>';
                  }
                }
              }
            }
          }
        },

        {
          'rule': 'color',
          'value': /^(?:#[A-F0-9]+|[A-Z]+|rgba?\s*\((?:\s*\d+\s*,){2,3}\s*\d+\s*\))$/i,
          'trans': function (element, value)
          {
            let i,
                blockTags;

            if (trueFontSizeTags.test(element.nodeName))
            {
              value = BEditor.utils.convertColorToHex(value);

              if (value)
              {
                value = '#' + value;

                if (element.nodeName === 'FONT')
                {
                  element.setAttribute('color', value);
                }
                else
                {
                  if (reTrueBlockTags.test(element.nodeName))
                  {
                    blockTags = element.querySelectorAll(trueBlockTags);

                    for (i = blockTags.length; i--;)
                    {
                      blockTags[i].innerHTML = '<font color="' + value + '">' + blockTags[i].innerHTML + '</font>';
                    }
                  }

                  element.innerHTML = '<font color="' + value + '">' + element.innerHTML + '</font>';
                }
              }
            }
          }
        },

        {
          'rule': 'fontFamily',
          'value': /./i,
          'trans': function (element, value)
          {
            let i,
                blockTags;

            if (trueFontSizeTags.test(element.nodeName))
            {
              if (value)
              {
                value = value.replace(/(?:"|&quot;|&#34;|&#x22;|<|&lt;|&#60;|&#x3C;|>|&gt;|&#62;|&#x3E;)/ig, '');

                if (value.toLowerCase().indexOf('awesome') !== -1 && value !== 'FontAwesome')
                {
                  value = value.replace(/^(\s*|.*?,\s*|.*?(?:['"]|&quot;))font\s*awesome[^,]*(,.*)?$/i, '$1FontAwesome$2');
                }

                if (element.nodeName === 'FONT')
                {
                  element.setAttribute('face', value);
                }
                else
                {
                  if (reTrueBlockTags.test(element.nodeName))
                  {
                    blockTags = element.querySelectorAll(trueBlockTags);

                    for (i = blockTags.length; i--;)
                    {
                      blockTags[i].innerHTML = '<font face="' + value + '">' + blockTags[i].innerHTML + '</font>';
                    }
                  }

                  element.innerHTML = '<font face="' + value + '">' + element.innerHTML + '</font>';
                }
              }
            }
          }
        },

        {
          'rule': 'textDecoration',
          'value': /.*?underline.*?/i,
          'tag': 'u',
          'isPart': true
        },

        {
          'rule': 'textDecoration',
          'value': /.*?line-through.*?/i,
          'tag': 'strike',
          'isPart': true
        },

        {
          'rule': 'verticalAlign',
          'value': /sub/i,
          'tag': 'sub'
        },

        {
          'rule': 'verticalAlign',
          'value': /super/i,
          'tag': 'sup'
        }
      ]
    };

    return pEditor.style.simplifier.simplifyFormatting(content, args);
  };
}